<template>
  <div class="tjEditor">
    <form @submit.prevent="createNote" role="form">
        <!-- text area with Add to note placeholder -->
        <mavon-editor
          rows="6"
          id="note-input"
          placeholder="Add to note..."
          class="mavonEditor"
          :showShortCut="false"
          v-model="customNote"
          :language="'en'"
          @save="createNote" />
      <div class="button-div d-grid">
        <button class="btn btn-primary" type="submit">Add note</button>
      </div>
    </form>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      customNote: '',
    };
  },
  methods: {
    createNote() {
      const value = {
        note: this.customNote,
        noteUrl: 'thoughtjumper-client.netlify.app/',
        type: 'note',
        timestamp: moment().format(),
      };

      const verb = {
        display: {
          en: 'NOTED',
        },
      };

      const data = {
        verb,
        value,
        actor: this.$store.state.auth.user,
        dataSource: 'tj-client',
      };
      // console.log(data);
      this.$store.dispatch('addToNote', data).then(() => {
        this.customNote = '';
      });
    },
  },
};
</script>

<style lang="scss" scoped>
 .tjEditor {
   width: 100%;
    height: 100%;
    position: relative;
    z-index: 0;

  form {
    width: 100%;
    height: 100%;
  }
  .mavonEditor {
    width: 100%;
    height: 92%;
  }
  .button-div {
    height: 7%;
  }
 }
</style>
